
import * as ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
const columnsProject=[
  {
    header: "Título",
    key: "title",
    width: 50,
  },
  {
    header: "Descripción",
    key: "description",
    width: 50,
  },
  {
    header: "Codigo",
    key: "code",
    width: 50,
  },
  {
    header: "Progreso",
    key: "progress",
    width: 50,
  },
];
const columnsProjectLider=[
  {
    header: "Nombres",
    key: "firstName",
    width: 50,
  },
  {
    header: "Apellidos",
    key: "lastName",
    width: 50,
  },
  {
    header: "Correo electronico",
    key: "email",
    width: 50,
  },
  {
    header: "Fecha de cumpleaños",
    key: "birthDate",
    width: 50,
  },
];
const columnsCenter=[
  {
    header: "Nombre del centro",
    key: "name",
    width: 50,
  },
  {
    header: "Acronimo del centro",
    key: "acronym",
    width: 50,
  },
  {
    header: "Nombres del Coordinador",
    key: "User",
    subKey:"firstName",
    width: 50,
  },
  {
    header: "Appellidos del Coordinador",
    key: "lastName",
    keyParent:"User",
    subKey:"lastName",
    width: 50,
  },
  {
    header: "Rol del coordinador",
    key: "CoordinatorRol",
    keyParent:"User",
    subKey:{
      subKeyParent:"SystemRol",
      subKeyChild: "name",
    },
    width: 50,
  },
  {
    header: "Correo electronico del coordinador",
    key: "emailCoordinator",
    keyParent:"User",
    subKey:{
      subKeyParent:"email",
    },
    width: 50,
  },
];
const columnsParticipants=[
  {
    header: "Nombres",
    key: "firstName",
    keyParent:"User",
    subKey: {
      subKeyParent:"firstName",
    },
    width: 50,
  },
  {
    header: "Apellidos",
    key: "lastName",
    keyParent:"User",
    subKey: {
      subKeyParent:"lastName",
    },
    width: 50,
  },
  {
    header: "Rol",
    key: "SystemRol",
    keyParent:"User",
    subKey: {
      subKeyParent:"SystemRol",
      subKeyChild: "name",
    },
    width: 50,
  },
];

const columnsDescriptions=[
  {
    header: "Resumen ejecutivo",
    key: "summaryExecutive",
    width: 50,
  },
  {
    header: "Introducion",
    key: "introduction",
    width: 50,
  },
  {
    header: "Antecedentes",
    key: "background",
    width: 50,
  },
  {
    header: "Caracterización del problema",
    key: "problem",
    width: 50,
  },
  {
    header: "Objetivo de estudio",
    key: "studyObject",
    width: 50,
  },
  {
    header: "Objetivo general",
    key: "generalObjetive",
    width: 50,
  },
  {
    header: "Objetivos específicos",
    key: "specificObjetive",
    width: 50,
  },
  {
    header: "Campo de acción",
    key: "fieldAction",
    width: 50,
  },
  {
    header: "Plan de trabajo",
    key: "workPlan",
    width: 50,
  },
  {
    header: "Características epistemológicas y metodológicas",
    key: "characteristic",
    width: 50,
  },
  {
    header: "Resultados Aspirados",
    key: "aspiredResult",
    width: 50,
  },
  {
    header: "Impacto Esperado",
    key: "expectedImpact",
    width: 50,
  },

];

const columnsBudget=[
  {
    header: "Nombre de la institución",
    key: "institutionName",
    keyParent:"Institution",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },
  {
    header: "Acronimo de la institución",
    key: "institutionAcronym",
    keyParent:"Institution",
    subKey: {
      subKeyParent:"shortName",
    },
    width: 50,
  },
  {
    header: "Cantidad de finanziamiento",
    key: "moneyBudget",
    width: 50,
  },
  // {
  //   header: "Simbolo de la moneda",
  //   key: "simbolMoney",
  //   keyParent:"Currency",
  //   subKey: {
  //     subKeyParent:"shortName",
  //   },
  //   width: 50,
  // },
  {
    header: "Nombre de la moneda",
    key: "nameMoney",
    keyParent:"Currency",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },
];

// const columnsDiffusionAuthors=[
//   {
//     header: "Nombre de la moneda",
//     key: "nameMoney",
//     keyParent:"Currency",
//     subKey: {
//       subKeyParent:"name",
//     },
//     width: 50,
//   },
// ]
const columnsPublication=[
  {
    header: "Titulo",
    key: "title",
    width: 50,
  },{
    header: "Tipo",
    key: "diffusionCategorytype",
    keyParent:"DiffusionCategory",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },
  {
    header: "Categoría",
    key: "diffusionCategoryCategory",
    keyParent:"DiffusionCategory",
    subKey: {
      subKeyParent:"firstParentCategory",
      subKeyChild:"name",
    },
    width: 50,
  },{
    header: "Estado",
    key: "diffusionCategoryStatus",
    keyParent:"StatusPublish",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },
  {
    header: "Fecha de creacion",
    key: "createdAt",
    width: 50,
  },
  {
    header: "Descripción",
    key: "description",
    width: 50,
  },
  {
    header: "Descargar el documento",
    key: "url",
    width: 50,
  },
  {
    header: "Codigo de la linea institucional ",
    key: "CodeLineInstitutional",
    keyParent:"Line",
    subKey: {
      subKeyParent:"code",
    },
    width: 50,
  },
  {
    header: "Titulo de la linea institucional",
    key: "TitleLineInstitutional",
    keyParent:"Line",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },
];

const columnsProjectProducts=[
  {
    header: "Titulo",
    key: "title",
    width: 50,
  },
  {
    header: "Observación",
    key: "observation",
    width: 50,
  },
  {
    header: "Fecha de creación",
    key: "date",
    width: 50,
  },
  {
    header: "Tipo de producto",
    key: "TypeProduct",
    keyParent:"TypeProduct",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },  
  {
    header: "Estado",
    key: "StatusPublish",
    keyParent:"StatusPublish",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },  
  {
    header: "Publicador",
    key: "Publisher",
    keyParent:"Publisher",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },  
  {
    header: "Progreso",
    key: "Progress",
    keyParent:"Progress",
    subKey: {
      subKeyParent:"stateProgress",
    },
    width: 50,
  }, 
  {
    header: "Codigo de la linea",
    key: "CodeLine",
    keyParent:"Line",
    subKey: {
      subKeyParent:"code",
    },
    width: 50,
  },  
  {
    header: "titulo de la linea",
    key: "TitleLine",
    keyParent:"Line",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },  
  {
    header: "Nombre de la actividad",
    key: "NameActivity",
    keyParent:"Activity",
    subKey: {
      subKeyParent:"name",
    },
    width: 50,
  },  
  {
    header: "Descripcion de la actividad",
    key: "DescriptionActivity",
    keyParent:"Activity",
    subKey: {
      subKeyParent:"description",
    },
    width: 50,
  },  
  {
    header: "Progreso de la actividad",
    key: "ProgressActivity",
    keyParent:"Activity",
    subKey: {
      subKeyParent:"progress",
    },
    width: 50,
  }, 
  {
    header: "Fecha de inicio de la actividad",
    key: "StartDateActivity",
    keyParent:"Activity",
    subKey: {
      subKeyParent:"startDate",
    },
    width: 50,
  }, 
  {
    header: "Fecha de finalización de la actividad",
    key: "EndDataActivity",
    keyParent:"Activity",
    subKey: {
      subKeyParent:"endDate",
    },
    width: 50,
  }, 
]
// const formatProjectRows = (data,columns) => {
//     console.log("data",data)
//     console.log("columns",columns)
//     let rows=[]
//     console.log("Rows",rows)
//     return rows
// }

// const createListOfUsers=(dataList=[],columns=[])=>{
//   let dataCreate=[]
//   dataList.map((data)=>{
//     dataCreate.push(createDataSimple(data,columns))
//   })
//   return dataCreate
// }

const createDataListUser=(dataList=[],columns=[],typeData)=>{
  let dataCreate=[]
  //console.log("dataList",dataList)
  dataList.map((data)=>{
    dataCreate.push(createDataSimple(data,columns,typeData))
  })
  return dataCreate
}

const createDataSimple=(data=[],columns=[],typeData)=>{
  let dataCreate={}
  let responseArray=[]
  let responseObject={}


  // let a="User"
  // let b="SystemRol"
  // let c="name"

  // console.log("User.name",data[a][b][c])
  if(data!=null){
    columns.map((column)=>{
      let keyCol= column.key
      let dataCol;
      if(column.hasOwnProperty("keyParent")){
        keyCol= column.keyParent;
      }
      dataCol=data[keyCol]
      // console.log("dataCol",dataCol,"dataColType",typeof dataCol,"Colunm",column,"column.hasOwnProperty(subKey)",column.hasOwnProperty("subKey"))
      // console.log("dataColTypeComparative",(typeof dataCol== 'object'))
      if((typeof dataCol=== 'object') && column.hasOwnProperty("subKey") && dataCol!= null ){
        let dataInside="sin datos"
        let SubKey=column.subKey
        if((typeof SubKey=== 'object') && SubKey.hasOwnProperty("subKeyParent")){
          // console.log(dataCol)
          // console.log(keyCol,SubKey.subKeyParent,SubKey.hasOwnProperty("subKeyChild"))
          if(SubKey.hasOwnProperty("subKeyChild")){
            dataInside=dataCol[SubKey.subKeyParent][SubKey.subKeyChild]
          }
          else{
            dataInside=dataCol[SubKey.subKeyParent]
          }
          //console.log("dataInside",dataInside)
        }else{
          dataInside=dataCol[SubKey]
        } 
        // console.log("dataInside",dataInside)
        keyCol= column.key
        dataCreate={
          ...dataCreate,
          [keyCol]: dataInside,
         }
      }else{
        keyCol= column.key
        dataCreate={ 
          ...dataCreate,
          [keyCol] : dataCol,
        }
      }
    })
  }

  if(typeData==="Array"){
    responseArray.push(dataCreate)
    return responseArray
  }
  else if(typeData==="Object"){
    responseObject=dataCreate
    return responseObject
    
  } 
}
const convertReactHtmlParser=(DescriptionProject)=>{
  let data={};
  Object.keys(DescriptionProject).map((description)=>{
    if(typeof DescriptionProject[description]=='string'){
      data={
        ...data,
        [description]: DescriptionProject[description].replace(/<[^>]+>/g, '')
      }
    }
  })
  return data
}

const exportMyProjects = (sheet, data,columns) => {
    sheet.columns = columns
    let totalColumns = sheet.columns.length;
    // let records = formatProjectRows(data,columns);
    let records = data;
    let rowHeader = sheet.getRow(0 + 1);
    for (let i = 1; i <= totalColumns; i++) {
        let cellHeader = rowHeader.getCell(i);
        cellHeader.style = {
          border: {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          },
        };
        cellHeader.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        cellHeader.font = {
          name: "Roboto",
          size: 14,
          bold: true,
        };
      }
      records.forEach((record) => {
        let row = sheet.addRow({ ...record });
        row.height = 50;
        row.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        for (let j = 1; j <= totalColumns; j++) {
          let cellData = row.getCell(j);
          cellData.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        }
      });
}

const XLSXGeneratorDocument={
  createReportProject:async(dataProject,Products,DiffusionProducts,Activities,UserProjectsProps)=>{
        const {
          Center,
          UserProjects,
          User,
          // LinesInstitutional,
          // LineProjects,
          InstitutionProjects,
          DescriptionProject,
        }=dataProject

        let description=convertReactHtmlParser(DescriptionProject);
        // const {
        //   Activity,
        //   Authors,
        //   FileProducts,
        //   Line,
        //   Progress,
        //   Publisher,
        //   StatusPublish,
        //   TypeArticle,
        //   TypeBook,
        //   TypeProduct,
        // }=products
          // console.log("ProjectDescriptions",dataProject)
          console.log("Products",Products)
          
          // console.log("diffusionProducts",DiffusionProducts)
          // console.log("activities",Activities)
          // console.log("userProjects",UserProjectsProps)
        let workbook = new ExcelJS.Workbook();
        const sheetProject = workbook.addWorksheet("Proyecto");
        const sheetProjectLider = workbook.addWorksheet("Lider");
        const sheetCenter = workbook.addWorksheet("Centro");
        const sheetParticipants = workbook.addWorksheet("Participantes");
        const sheetBudget = workbook.addWorksheet("Financiamiento");
        // const sheetExecutionTime = workbook.addWorksheet("Periodo de ejecucción");
        const sheetDescriptions = workbook.addWorksheet("Descripion");
        const sheetResult = workbook.addWorksheet("Resultados");
        const sheetPublicacion = workbook.addWorksheet("Publicaciones");
        

        exportMyProjects(sheetProject,createDataSimple(dataProject,columnsProject,"Array"),columnsProject)
        exportMyProjects(sheetProjectLider,createDataSimple(User,columnsProjectLider,"Array"),columnsProjectLider)
        exportMyProjects(sheetCenter,createDataSimple(Center,columnsCenter,"Array"),columnsCenter)
        exportMyProjects(sheetParticipants,createDataListUser(UserProjects,columnsParticipants,"Object"),columnsParticipants)
        exportMyProjects(sheetBudget,createDataListUser(InstitutionProjects,columnsBudget,"Object"),columnsBudget)
        exportMyProjects(sheetDescriptions,createDataSimple(description,columnsDescriptions,"Array"),columnsDescriptions)
        exportMyProjects(sheetPublicacion,createDataListUser(DiffusionProducts,columnsPublication,"Object"),columnsPublication)
        // exportMyProjects(sheetPublicacion,createDataListUser(DiffusionProducts[0],columnsDiffusionAuthors,"Object"),columnsDiffusionAuthors)
        exportMyProjects(sheetResult,createDataListUser(Products,columnsProjectProducts,"Object"),columnsProjectProducts)
        workbook.xlsx
            .writeBuffer()
            .then((buffer) =>
                FileSaver.saveAs(
                    new Blob([buffer]),
                    `Proyecto ${dataProject.title}_${Date.now()}.xlsx`
                )
            )
            .catch((err) => console.log("Error writing excel export", err));
    },

}

export default XLSXGeneratorDocument;